import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-xl text-[#00b36c] text-start font-extrabold my-3" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-1 right-1 -translate-y-1/2 translate-x-1/2 flex size-5"
}
const _hoisted_3 = { class: "text-[12px] md:text-[14px] text-amber-950 text-center font-semibold whitespace-nowrap" }

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupWalletNavbar = _resolveComponent("PopupWalletNavbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabPanels = _resolveComponent("TabPanels")
  const _component_Tab = _resolveComponent("Tab")
  const _component_TabList = _resolveComponent("TabList")
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupWalletNavbar),
    _createVNode(_component_Tabs, {
      value: _ctx.tabs,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.tabs) = $event)),
      "show-navigators": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanels, { pt: { root: 'p-0! bg-transparent!' } }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, {
              value: _ctx.tabs,
              class: "m-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.tabTitleMap[_ctx.tabs]), 1 /* TEXT */),
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabComponentMap[_ctx.tabs]), { key: _ctx.tabs }))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"])
          ]),
          _: 1 /* STABLE */
        }),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-[16px] font-semibold text-amber-100 my-2" }, "ช่องทางฝาก", -1 /* HOISTED */)),
        _createVNode(_component_TabList, { pt: {
          root: '',
          tabList: 'grid! grid-cols-3 gap-2.5 w-full border-b-0! bg-transparent!',
          activeBar: 'hidden!',
        } }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabTitleMap, (label, key) => {
              return (_openBlock(), _createBlock(_component_Tab, {
                onClick: $event => (_ctx.selectTab(key)),
                value: key,
                class: "relative z-0 flex items-center justify-center gap-1 md:gap-2",
                pt: { root: `text-xs border-0! text-black! !px-0 !py-3.5 bg-[url('https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-wallet-de.webp')]! bg-size-[100%_100%]!` }
              }, {
                default: _withCtx(() => [
                  (key === 'autopeer')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("svg", {
                          class: "absolute inline-flex h-full w-full animate-ping rounded-full text-red-400 opacity-75",
                          "aria-hidden": "true",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          fill: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", { d: "M8.597 3.2A1 1 0 0 0 7.04 4.289a3.49 3.49 0 0 1 .057 1.795 3.448 3.448 0 0 1-.84 1.575.999.999 0 0 0-.077.094c-.596.817-3.96 5.6-.941 10.762l.03.049a7.73 7.73 0 0 0 2.917 2.602 7.617 7.617 0 0 0 3.772.829 8.06 8.06 0 0 0 3.986-.975 8.185 8.185 0 0 0 3.04-2.864c1.301-2.2 1.184-4.556.588-6.441-.583-1.848-1.68-3.414-2.607-4.102a1 1 0 0 0-1.594.757c-.067 1.431-.363 2.551-.794 3.431-.222-2.407-1.127-4.196-2.224-5.524-1.147-1.39-2.564-2.3-3.323-2.788a8.487 8.487 0 0 1-.432-.287Z" })
                        ], -1 /* HOISTED */),
                        _createElementVNode("svg", {
                          class: "size-5 relative inline-flex rounded-full text-red-500",
                          "aria-hidden": "true",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          fill: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", { d: "M8.597 3.2A1 1 0 0 0 7.04 4.289a3.49 3.49 0 0 1 .057 1.795 3.448 3.448 0 0 1-.84 1.575.999.999 0 0 0-.077.094c-.596.817-3.96 5.6-.941 10.762l.03.049a7.73 7.73 0 0 0 2.917 2.602 7.617 7.617 0 0 0 3.772.829 8.06 8.06 0 0 0 3.986-.975 8.185 8.185 0 0 0 3.04-2.864c1.301-2.2 1.184-4.556.588-6.441-.583-1.848-1.68-3.414-2.607-4.102a1 1 0 0 0-1.594.757c-.067 1.431-.363 2.551-.794 3.431-.222-2.407-1.127-4.196-2.224-5.524-1.147-1.39-2.564-2.3-3.323-2.788a8.487 8.487 0 0 1-.432-.287Z" })
                        ], -1 /* HOISTED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(label), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "value"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */,
      __: [2]
    }, 8 /* PROPS */, ["value"])
  ], 64 /* STABLE_FRAGMENT */))
}